import { LocaleStartParams } from '@platform-frontend/transloco';
import { SimpleRouterNavigationExtras } from '@platform-frontend/util';
import { AccountStartParams } from './account-start-params';

export interface AccountNavigationExtras<T extends LocaleStartParams = LocaleStartParams> extends SimpleRouterNavigationExtras, AccountStartParams<T> {}
